import Point from "../entities/Point";
import RedPoint from "../entities/RedPoint";
import generatePoints from "../utils/generatePoints";
import { normalizeRadian } from "../utils/normalizeRadian";
import { Coord, RedPointRadianInfo } from "../types/Interface";
import { RootEventBus, EnumRootEventBus } from "./RootEventBus";


export default class BasePointManager {
  static instance: BasePointManager;
  private RootEventBus = RootEventBus;

  cCoord: Coord;
  circleRadius: number;
  pointInitialRadians: number[] = [];
  pointRadians: number[] = [];
  pointRefRadians: number[] = [];
  pointRedCoords: Coord[] = [];

  circlePoint: Point;
  RedPointsArr: RedPoint[] = [];

  constructor(cCoord: Coord, CIRCLE_RADIUS: number, RADIANS: number[]) {
    if (!BasePointManager.instance) {
      BasePointManager.instance = this;
    }
    const radians = RADIANS.map(r => normalizeRadian(r));
    this.cCoord = cCoord;

    this.circleRadius = CIRCLE_RADIUS;
    this.pointInitialRadians = [...radians];
    this.pointRefRadians = [...radians];
    this.pointRadians = radians;

    this.RedPointsArr = Array(radians.length)
      .fill(null)
      .map((_, vI) => `p${vI + 1}`)
      .map(pT => new RedPoint(pT, this.cCoord, (pT: string) => this.emitRedPointTag(pT), () => this.emitRedPointTag("")));

    this.circlePoint = new Point(this.cCoord);
    this.pointRedCoords = generatePoints(this.cCoord, this.pointRadians, this.circleRadius);

    this.RootEventBus.on(EnumRootEventBus.setRedPointCoord, (arr) => this.setRadian(arr));
    this.RootEventBus.on(EnumRootEventBus.setRefRadians, () => this.setRefRadians())
  }

  static getInstance = () => BasePointManager.instance;
  setAllVisible = (v: boolean) => [this.circlePoint, ...this.RedPointsArr].forEach(p => p.visible = v);
  getRadians = () => this.pointRadians;
  getInitialRadians = () => this.pointInitialRadians;
  getRefRadians = () => this.pointRefRadians;
  getRedPoints = () => this.RedPointsArr;
  getPoints = () => [this.circlePoint, ...this.RedPointsArr];
  getPointsCoord = () => [this.cCoord, ...this.pointRedCoords];
  getRedPointsCoord = () => this.pointRedCoords;
  addSetCoordExtraCode = (cb: () => void) => this.addSetCoordExtraCode = cb;
  emitRedPointTag = (PointTag: string) => this.RootEventBus.emit(EnumRootEventBus.setRedPointTag, PointTag);
  setRefRadians = () => this.pointRefRadians = [...this.pointRadians];


  //setCoord and setRadius are the public-facing method that can be overridden by subclasses.
  setCoord() { this._setCoord() };
  setRadian(pointInfoArr: RedPointRadianInfo[], isSlider = false) { this._setRadian(pointInfoArr, isSlider) };
  
  draw() {
    const points = this.getPoints();
    [this.circlePoint, ...this.RedPointsArr].forEach((p, pI) => p.draw(points[pI]));
  }

  _setRadian(pointInfoArr: RedPointRadianInfo[], isSlider = false) {
    const points = this.getRedPoints();

    points.forEach((p, pI) => {
      pointInfoArr.forEach((pInfo) => {
        if (p.tag == pInfo.pTag) {
          const radian = normalizeRadian(pInfo.radian);
          this.pointRadians[pI] = radian;
          if (isSlider == false) {
            this.pointRefRadians[pI] = radian
          };
          this.setCoord();
        }
      })
    });
  }
  _setCoord() {
    this.pointRedCoords = generatePoints(this.cCoord, this.pointRadians, this.circleRadius);
    this.RedPointsArr.forEach((point, pIndex) => Object.assign(point, this.pointRedCoords[pIndex]));
    this.RootEventBus.emit(EnumRootEventBus.drawElements);
  }
}